import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { X } from "lucide-react";

interface CounselDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CounselDetailsModal: React.FC<CounselDetailsModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[500px]"
      edges="rounded-2xl"
    >
      <div className="p-8 flex flex-col gap-y-6 relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-[#1A1A1A] hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <h2 className="text-xl font-bold text-[#1A1A1A]">Details of Counsel</h2>

        <div className="flex flex-col gap-y-6">
          <h3 className="font-bold text-[#1A1A1A] text-base">
            Defendant Counsel
          </h3>

          <div className="flex flex-col gap-y-4">
            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">Full name</label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                James Bassey
              </div>
            </div>

            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">
                Name of law firm
              </label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                J&B Legal Practitioners
              </div>
            </div>

            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">Address</label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                267 Clifford Road Lagos
              </div>
            </div>

            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">Email address</label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                jamesbassey@gmail.com
              </div>
            </div>

            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">Phone number</label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                080384828848
              </div>
            </div>

            <div className="flex flex-col gap-y-1.5">
              <label className="text-sm text-[#98A2B3]">Whatsapp number</label>
              <div className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#1A1A1A] text-base">
                080384828848
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-[#00B074] text-white rounded-lg py-3 font-medium hover:bg-[#009b65] transition-colors mt-2"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
};

export default CounselDetailsModal;
